import {getAll} from "@/api/workplace.js"
import {getAll as getAllClType} from "@/api/cailiaotype.js"
import {getList as getpaylist} from "@/api/paylog.js"

let user = sessionStorage.getItem("userinfo")
user = JSON.parse(user)



/**
 * 增删改查
 */
export const curdfn = {
	addcld(showModal){
		this.formData = {
			cmpid:user.cmpid,
			excels:[],
			clinfo:[
				{type:undefined,price:"",num:"",key:(new Date()).getTime(),sum:""}
			]
		}
		showModal("添加材料账单",[
			{"value":"name","text":"姓名"}
		],"700px")
	},
	async updatecldan(record,showModal){
		let {clinfo,idcard,excels,starttime,endtime,workplace} = record
		console.log(record)
		this.formData = {...record}
		getpaylist({idcard,time1:starttime,time2:endtime,workplace}).then(ret=>{
			if(ret.code == 0){
				let {data:{money}} = ret
				this.formData = {...this.formData,fafang:money}
			}
		})
		showModal("修改材料账单",[
			{"value":"idcard","text":"身份证号"}
		],"700px")
	},
	deletecldan(record,showDelConfirm){
		this.formData = {...record}
		showDelConfirm()
	}
}

/**
 * 所在工地和用工类型相关
 */
export const tabledatatransform = {
	getworkpalceArrary(){
		getAll({cmpid:user.cmpid}).then(ret=>{
			if(ret.code == 0){
				let {data} = ret
				this.workplaceArray = data
			}
		})
	},
	getciaoliaotypeArray(){
		getAllClType({cmpid:user.cmpid}).then(ret=>{
			if(ret.code == 0){
				let {data} = ret
				this.cltypeArray = data
			}
		})
	},
	//表格数据处理函数
	workplaceshow(id){
		let wp = this.workplaceArray.find(item=>item.id == id)
		if(wp){
			return wp["name"]
		}else{
			return  ""
		}
	},
	cltypeshow(id){
		let rt = this.roomtypeArray.find(item=>item.id == id)
		if(rt){
			return rt["name"]
		}else{
			return  ""
		}
	},
}

/**
 * 表单中材料数据的先关操作
 */
export const cailiaoitem ={
	addclinfo(){
		this.formData.clinfo.push({
			type:undefined,price:"",num:"",key:(new Date()).getTime(),sum:""
		})
	},
	delclinfo(key){
		this.formData.clinfo =  this.formData.clinfo.filter(item=>item.key != key)
	},
	
	getsum(clitem,id){
		this.formData.clinfo[id]["sum"] = clitem.price * clitem.num
	},
}

